import React from 'react';

const Payments = () => {
  return (
    <div>
      <h4>Payments</h4>
      <p>This page is under construction.</p>
    </div>
  );
};

export default Payments;
